module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-130.63cb2ea.woff2";